import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const productModifications = 'ProductModifications'

export const getModifiedProducts = (filters) => {
  return axios.post(`/${productModifications}/PaginatedAndFiltered`, filters)
}

export const createModifiedProduct = (data) => {
  return axios.post(`/${productModifications}`, data)
}

export const getModifiedProduct = (id, headers= {}) => {
  return axios.get(`/${productModifications}/${id}`,{headers})
}

export const updateModifiedProduct = (data) => {
  return axios.put(`/${productModifications}`, data)
}
